import React, { Component } from 'react';
import DataAPI from '../../../Utils/Api';

interface IState {
    notifications
}

class Notifications extends Component<{}, IState> {
    constructor(props) {
        super(props);
        this.state = {
            notifications: [
            ]
        }
    }

    addNewTab = data => {
        var regex1 = /a href="http/gi;
		var regex2 = /a href="www/gi;
		let x = data.replace(regex1, "a target='_blank' href=\"http")
					.replace(regex2, "a target='_blank' href=\"www");
		return x;
    };

    getAllNotifications() {
        DataAPI().post('/GetNotification', {})
        .then((response) => {
            this.setState({ notifications: response.data })
        })
        .catch((error) => {
            console.log(error);
        })
    }

    closeNotification(notifId, userId) {
        DataAPI().post('/DeleteNotification', {
            userId: userId,
            notificationId: notifId.toString()
        })
        .then((response) => {
            if (response.data.response === "Success") {
                this.getAllNotifications();
            }
        })
        .catch((error) => {
            console.log(error);
        })
    }

    componentDidMount() {
        // this.getAllNotifications();
    }


    render() {
        return (
            <React.Fragment>
                <span style={{ color: "#367feb", fontSize: "15px" }}>({this.state.notifications.length})</span>
                {this.state.notifications.map((e, i) => {
                    return (
                        <div className="sf-each-offer" key={i}>
                            <div style={{ display: "inline-block", width: "220px" }}>
                                <b style={{ fontSize: "13px" }}>{e.notificationTitle}</b>
                                <br />
                                <span style={{ fontSize: "12px", color: "#6e6e6e" }}>
                                    <div
                                    dangerouslySetInnerHTML={{
                                        __html: this.addNewTab(e.notificationMsg)
                                    }}
                                    ></div>
                                </span>
                                <br />
                            </div>
                            {/* <span style={{ fontSize: "8px", float: "right" }}>{TimeUtil.getCurrentTime(new Date())}</span> */}
                            <span style={{ fontSize: "14px", float: "right", cursor: "pointer" }} 
                            onClick={this.closeNotification.bind(this, e.notificationId, e.userId)}>×</span>
                        </div>
                    )
                })}
            </React.Fragment>
        );
    }
}

export default Notifications;